export const landingPageEvent = () => {
  fbq("track", "lead-landingPage");
};
export const paperTestYoutube = () => {
  fbq("trackCustom", "Paper Test Youtube");
};
export const quickstartYoutube = () => {
  fbq("trackCustom", "Quickstart-youtube");
};
export const FAQPageEvent = () => {
  fbq("trackCustom", "FAQ-page-event");
};
export const webinarPageEvent = () => {
  fbq("trackCustom", "webinar-page-event");
};
export const VideosPageEvent = () => {
  fbq("trackCustom", "videos-page-event");
};
